// extracted by mini-css-extract-plugin
export var cardIcon = "_9o-5";
export var cardIconUnframed = "_9o-9";
export var checkboxCard = "_9o-0";
export var checkboxCardSelected = "_9o-4";
export var disabled = "_9o-2";
export var interactive = "_9o-1";
export var outerBorder = "_9o-3";
export var spacerMedium = "_9o-8";
export var spacerSmall = "_9o-7";
export var spacerXsmall = "_9o-6";